import React from 'react';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { FormCotacao } from '../../components/FormCotacao';

export default function CadastrarCotacaoPage() {

  const defaultValues = {
      "pessoaId" : 0,
      "ativo" : false
  }

  return (
    <div>
      <MenuMain>
         <FormCotacao
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

